import React, { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import './index.scss';

const Radio = ({ component: Component = 'label', children, ...props }) => {
  const inputRef = useRef(null);
  const inputRefChecked =
    inputRef && inputRef.current && inputRef.current.checked;

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(inputRef.current.checked);
  }, [inputRefChecked]);

  return (
    <Component
      className={classNames('radio', { checked }, props.className)}
      data-testid={props['data-testid']}
    >
      <input ref={inputRef} {...props} type="radio" />
      <div className="radio-custom">
        <span>{children}</span>
      </div>
    </Component>
  );
};

export default Radio;
